<template>
  <div class="tw-relative tw-flex tw-justify-between tw-items-center -tw-mx-2 tw-h-14">
    <div class="tw-h-px tw-absolute tw-bg-status-divider tw-mx-10 tw-left-0 tw-right-0" />
    <div
      v-for="status in statuses"
      :key="status.id"
      class="tw-relative tw-z-10 tw-group tw-cursor-pointer tw-rounded-full"
      :class="activeOrHoveredStatus?.id !== status?.id ? 'tw-p-2' : ''"
      @mouseenter="onMouseEnter(status)"
      @mouseleave="onMouseLeave(status)"
      @click="onStatusClick(status)"
    >
      <div class="tw-absolute tw-inset-0 tw-rounded-xl tw-pointer-events-none tw-group-hover:tw-bg-transparent" />
      <div
        class="tw-flex tw-items-center tw-overflow-hidden tw-bg-gray tw-rounded-xl tw-font-medium"
        :class="[
          activeOrHoveredStatus?.id === status?.id
            ? 'tw-w-[40vw] md:tw-w-[30vh] tw-pl-3 tw-pr-6 tw-py-3'
            : 'tw-w-8 tw-h-8',
          getStatusClasses(status),
        ]"
      >
        <div
          class="tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-w-8 tw-h-8"
          :class="getStatusHumanOrderClasses(status)"
        >
          {{ status.human_order }}
        </div>
        <span
          class="tw-text-xs tw-text-white tw-ml-2 tw-break-words tw-whitespace-normal tw-leading-5"
          :class="[
            activeOrHoveredStatus?.id === status?.id ? 'tw-opacity-100' : 'tw-opacity-0',
          ]"
        >
          {{ status.status_type_name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IStepProgressWithLabels',
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
    onStatusClick: {
      type: Function,
      default: () => {},
    },
    activeStatus: {
      type: Object,
      default: () => {},
    },
    isObtained: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      hoveredStatus: null,
      hoverCooldown: false,
    };
  },
  computed: {
    activeOrHoveredStatus() {
      return this.hoveredStatus ?? this.activeStatus;
    },
    currentStatus() {
      return this.statuses.find((status) => status.is_current);
    },
  },
  methods: {
    onMouseEnter(status) {
      if (this.hoverCooldown) return;
      this.hoveredStatus = status;
    },
    onMouseLeave(status) {
      if (this.hoveredStatus?.id === status?.id) {
        this.hoveredStatus = null;
      }
    },
    getStatusHumanOrderClasses(status) {
      const isActiveOrHovered = this.activeOrHoveredStatus?.id === status?.id;

      if (this.currentStatus.human_order > status.human_order || this.isObtained) {
        return isActiveOrHovered ? 'tw-bg-white tw-text-universal' : 'tw-bg-universal tw-text-white';
      }

      if (this.currentStatus.human_order === status.human_order) {
        return isActiveOrHovered ? 'tw-bg-white tw-text-primary' : 'tw-bg-primary tw-text-white';
      }

      return isActiveOrHovered ? 'tw-bg-white tw-text-status-upcoming' : 'tw-bg-gray tw-text-status-upcoming';
    },
    getStatusClasses(status) {
      if (this.activeOrHoveredStatus?.id === status?.id) {
        if (this.currentStatus.human_order > status.human_order || this.isObtained) return 'tw-bg-universal';
        if (this.currentStatus.human_order === status.human_order ) return 'tw-bg-primary';
        if (this.currentStatus.human_order < status.human_order) return 'tw-bg-status-upcoming';
      }
      return 'tw-bg-white';
    },
  },
};
</script>

<style scoped>
* {
  transition: all 0.3s ease;
}

.tw-opacity-0 {
  transition: opacity 0.3s ease;
}

.tw-opacity-100 {
  transition: opacity 0.3s ease;
}

.tw-rounded-xl {
  transition: flex-grow 0.3s ease, padding 0.3s ease, background-color 0.3s ease;
}
</style>
